import React, { FC } from "react";
import { connect } from "react-redux";
import { Outlet } from "react-router-dom";
import ChatBubble from "../../molecules/ChatBubble/ChatBubble";
import AppearanceToggle from "../../molecules/AppearanceToggle/AppearanceToggle";
import "./RetailerPage.less";

const RetailerPage: FC = () => {
    return (
        <div className="retailer-page">
            <Outlet />
            <ChatBubble />
            <AppearanceToggle />
        </div>
    );
};

export default connect(null)(RetailerPage);
